import { Component, Input } from '@angular/core';

@Component({
    selector: 'c-tutorial-step',
    templateUrl: './tutorial-step.component.html',
    styleUrls: ['./tutorial-step.component.scss'],
    standalone: false
})
export class TutorialStepComponent {
  @Input() title: string;
  @Input() src: string;
  @Input() description: string;
}
